import React, { useState, useContext, createContext } from 'react';
import { OverflowMenu, styled } from '@ui-kitten/components';
import DNACard from '@alucio/lux-ui/src/components/layout/DNACard/DNACard';
import DNABox from '@alucio/lux-ui/src/components/layout/DNABox/DNABox';
import DNAText from '@alucio/lux-ui/src/components/type/DNAText/DNAText';
import DNAIcon from '@alucio/lux-ui/src/components/visual/DNAIcon/DNAIcon';
import Iffy from '@alucio/lux-ui/src/components/util/Iffy/Iffy';
import util from '@alucio/lux-ui/src/components/util';
import findChildren from '@alucio/lux-ui/src/util/findChildren';
export var DNAContextMenuAppearanceEnum;
(function (DNAContextMenuAppearanceEnum) {
    DNAContextMenuAppearanceEnum["default"] = "default";
})(DNAContextMenuAppearanceEnum || (DNAContextMenuAppearanceEnum = {}));
export const DNAContextMenuAppearanceKeys = Object.keys(DNAContextMenuAppearanceEnum);
export const DNAContextMenuContext = createContext(() => { });
function parseThemeStyle(source) {
    const { customAttr, ...container } = source;
    return {
        container,
        customStyle: {
            customAttr,
        },
    };
}
export const DNAContextMenu = (props) => {
    const { eva, children, ...rest } = props;
    const [isVisible, setIsVisible] = useState(false);
    const themeStyles = parseThemeStyle(eva?.style);
    const containerStyle = util.mergeStyles(props, themeStyles.container);
    const [[anchorChild], , restChildren] = findChildren(DNAContextMenuAnchor, children);
    const [[itemsChild]] = findChildren(DNAContextMenuItems, restChildren);
    const [itemChildren] = findChildren(DNAContextMenuItem, itemsChild?.props?.children || []);
    const moddedAnchorChild = React.cloneElement(anchorChild.props.children, {
        onPress: () => {
            anchorChild?.props?.children?.props?.onPress?.();
            setIsVisible(true);
        },
    });
    return (
    // @ts-ignore
    <OverflowMenu visible={isVisible} style={containerStyle} {...rest} 
    // @ts-ignore
    anchor={() => moddedAnchorChild} onBackdropPress={() => setIsVisible(false)}>
      <DNAContextMenuContext.Provider value={setIsVisible}>
        {itemChildren}
      </DNAContextMenuContext.Provider>
    </OverflowMenu>);
};
export const DNAContextMenuAnchor = (props) => {
    const { children } = props;
    return children;
};
export const DNAContextMenuItems = (props) => {
    const { children } = props;
    return children;
};
export const DNAContextMenuItem = (props) => {
    const { title, collapseOnPress = true, icon, onPress, delay = 0, children, status, childrenWrapper, } = props;
    const setIsVisible = useContext(DNAContextMenuContext);
    const wrappedOnPress = () => {
        if (collapseOnPress)
            setIsVisible(false);
        setTimeout(onPress, delay);
    };
    if (children) {
        return children;
    }
    const renderedItem = (<DNACard interactive="pressable" appearance="flat" onPress={wrappedOnPress} testID={`context-menu-row-${title?.toLocaleLowerCase().replaceAll(' ', '-')}`}>
      <DNABox alignY="center" spacing="small" style={{ paddingVertical: 12, paddingHorizontal: 24 }}>
        <Iffy is={icon}>
          <DNAIcon.Styled appearance="ghost" status={status || 'subtle'} name={icon}/>
        </Iffy>
        <DNAText testID="context-menu-row-label" status={status || 'neutral'}>
          {title}
        </DNAText>
      </DNABox>
    </DNACard>);
    return childrenWrapper
        ? childrenWrapper(renderedItem)
        : renderedItem;
};
DNAContextMenu.displayName = 'DNAContextMenu';
DNAContextMenuAnchor.displayName = 'DNAContextMenuAnchor';
DNAContextMenuItems.displayName = 'DNAContextMenuItems';
DNAContextMenuItem.displayName = 'DNAContextMenuItem';
DNAContextMenu.Anchor = DNAContextMenuAnchor;
DNAContextMenu.Items = DNAContextMenuItems;
DNAContextMenu.Item = DNAContextMenuItem;
// [TODO]: Allow Styled type to handle compound components
export default styled('DNAContextMenu')(DNAContextMenu);
//# sourceMappingURL=DNAContextMenu.js.map